import React from 'react'
import CurrencyFormat from 'react-currency-format'
import "./Subtotal.css"
import  { useStateValue } from "./StateProvider";
import { getBasketTotal } from "./reducer";
import { useHistory } from "react-router-dom";

function Subtotal() {

    const history = useHistory();
    const [{ basket }, dispatch] = useStateValue();

    return (
        <div className="subtotal">
            <CurrencyFormat 
            renderText={(value) => (
                <>
                <p>
                    Subtotal ({basket.length} itmes) :
                    <strong>{ value }</strong>
                    {/* Subtotal (0 itmes) :
                    <strong> 0 </strong> */}
                    
                </p>
                <small className="subtotal_gift">
                    <input type="checkbox" />
                    This order contains a gift
                </small>
                </>
            )}
            decimalScale={2}
            value={getBasketTotal(basket)}
            // value={0}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
                />
                <button onClick={e => history.push('/payment')}>Proceed to checkout</button>
        </div>
    )
}

export default Subtotal
